export interface SensorReading {
  timestamp: number;
  value: number;
  quality: number; // 0-1, signal quality
  raw?: number;
}

export interface SensorConfig {
  id: string;
  type: SensorType;
  name: string;
  sampleRate: number;
  calibrated: boolean;
  connected: boolean;
  baseline?: number;
  sensitivity: number;
}

export enum SensorType {
  HEART_RATE = 'heart_rate',
  EEG = 'eeg',
  GSR = 'gsr',
  TEMPERATURE = 'temperature',
  BREATHING = 'breathing'
}

export interface SensorData {
  sensorId: string;
  readings: SensorReading[];
  lastUpdate: number;
  anomalies: AnomalyEvent[];
}

export interface AnomalyEvent {
  timestamp: number;
  type: 'spike' | 'dropout' | 'noise' | 'drift';
  severity: number;
  description: string;
}

export interface BiometricSignature {
  heartRateVariability: number;
  eegCoherence: number;
  gsrStability: number;
  overallCoherence: number;
  spiritualAlignment: number;
}